import { Globe } from 'lucide-react';

import { getRegionIcon } from 'constant/model-metadata';
import { LLM_MODEL_REGIONS } from 'constant/llm-model';

const REGION_LOGOS: Record<string, string | undefined> = {
  eu: getRegionIcon(LLM_MODEL_REGIONS.EU),
  ch: getRegionIcon(LLM_MODEL_REGIONS.CH),
  global: undefined,
};

const normalizeRegion = (region?: string | null) => region?.toLowerCase();

type AgentModelRegionLogoProps = {
  region?: string | null;
  className?: string;
};

export function AgentModelRegionLogo({ region, className = 'h-4 w-4' }: AgentModelRegionLogoProps) {
  const normalizedRegion = normalizeRegion(region);
  if (!normalizedRegion) return null;

  if (normalizedRegion === 'global') {
    return <Globe className={`${className} text-muted-foreground`} />;
  }

  const icon = REGION_LOGOS[normalizedRegion];
  if (!icon) return null;

  return (
    <img
      src={icon}
      alt={normalizedRegion.toUpperCase()}
      className={`${className} shrink-0 object-contain`}
    />
  );
}
